module.exports = __webpack_public_path__ + "static/media/timer.3b442c63.png";